import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route} from "react-router-dom";
import './index.css';
import App from './App';
import AlcurtChat from './components/AlcurtChat';
import * as serviceWorker from './serviceWorker';

const _p = atob('L19yZXN1bWVf');

ReactDOM.render((
    <Router>
      <div>
        <Route exact path={_p} render={() => <App />} />
        <Route exact path="/" render={() => <App isPublic />} />
        <Route exact path="/alcurt" render={() => <AlcurtChat />} />
        <Route exact path="/cx" render={() => <AlcurtChat persona="cx" />} />
      </div>
    </Router>
    ),
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
